<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import Pagination from '@/Components/Pagination.vue'
import HeadingTwo from '@/Components/HeadingTwo.vue'
import Paragraph from '@/Components/Paragraph.vue'

const props = defineProps({
    blogs: {
        type: Object,
        required: true,
    },
})
</script>

<template>
    <AppLayout>
        <template #content>
            <section class="py-12 sm:py-24">
                <div class="section--width">
                    <HeadingTwo
                        class="!mt-0"
                        value="Články, tipy a návody"
                    />
                    <Paragraph> Dozvíte se zde spoustu užitečných informací, tipů a návodů. </Paragraph>

                    <div
                        v-if="blogs.data.length > 0"
                        class="mt-16 grid grid-cols-1 gap-4 sm:mt-20 lg:mt-24 lg:grid-cols-2 xl:grid-cols-3"
                    >
                        <article
                            v-for="blog in blogs.data"
                            :key="blog.id"
                            class="card faster-animation relative flex w-full flex-col items-center justify-between hover:ring-white/20"
                        >
                            <Link
                                :href="route('blogs.show', blog.slug)"
                                class="absolute inset-0 z-10"
                            />

                            <div class="group relative w-full">
                                <div class="">
                                    <img
                                        :src="blog.relationships?.thumbnail?.original_url"
                                        :alt="blog.title"
                                        class="h-48 w-full rounded-lg object-contain"
                                    />
                                </div>

                                <h3
                                    class="mt-5 text-center text-2xl/6 leading-8 font-semibold dark:text-zinc-200 dark:group-hover:text-white"
                                >
                                    {{ blog.title }}
                                </h3>
                            </div>

                            <div class="mt-8 text-xs">
                                <time
                                    :datetime="blog.published_at"
                                    class="text-zinc-500"
                                >
                                    {{ blog.published_at_human }}
                                </time>
                            </div>
                        </article>

                        <div class="col-span-full">
                            <Pagination :pages="blogs.meta" />
                        </div>
                    </div>
                </div>
            </section>
        </template>
    </AppLayout>
</template>
